/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import getters from '@/store/modules/ui/getters'

getters.getPackageVersion = (state) => {
  return state.packageVersion
}

getters.getRightActiveComponent = (state) => {
  return state.rightActiveComponent
}

getters.getLeftActiveComponent = (state) => {
  return state.leftActiveComponent
}

getters.getTopActiveComponent = (state) => {
  return state.topActiveComponent
}

getters.getBottomActiveComponent = (state) => {
  return state.bottomActiveComponent
}

getters.blockScrollbar = (state, getters) => {
  let bottom = state.bottomActiveComponent.component
  let left = state.leftActiveComponent.component
  let right = state.rightActiveComponent.component
  let top = state.topActiveComponent.component
  return !!top || !!bottom || !!left || !!right
}

getters.getGenericModalComponent = (state) => {
  return state.genericModalComponent
}

getters.getSubMenuActiveComponent = (state) => {
  return state.subMenuActiveComponent
}

getters.getCountry = (state) => {
  if (state.currentCountry) {
    return state.currentCountry.country
  } else {
    return ''
  }
}

getters.getHeaderPageTitle = (state) => {
  return state.headerPageTitle
}

getters.getBodyClass = (state) => {
  return state.bodyClass
}

getters.menu = (state) => {
  return state.menu
}

export default {
  ...getters
}
